import { createApp } from 'vue'
import TaskWorkbench from '../components/TaskWorkbench.vue'

function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return

  const notifyUpdateAvailable = () => {
    window.dispatchEvent(new CustomEvent('taskmagic:pwa-update-available'))
  }

  const watchRegistration = (registration) => {
    if (registration.waiting) {
      notifyUpdateAvailable()
    }

    registration.addEventListener('updatefound', () => {
      const installing = registration.installing
      if (!installing) return

      installing.addEventListener('statechange', () => {
        if (installing.state === 'installed' && navigator.serviceWorker.controller) {
          notifyUpdateAvailable()
        }
      })
    })
  }

  const register = async () => {
    try {
      const registration = await navigator.serviceWorker.register('/service-worker.js')
      watchRegistration(registration)
    } catch (error) {
      console.error('Service worker registration failed', error)
    }
  }

  if (document.readyState === 'complete') {
    register()
  } else {
    window.addEventListener('load', register, { once: true })
  }

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    window.location.reload()
  })
}

// Component registry
const components = {
  TaskWorkbench,
}

document.addEventListener('DOMContentLoaded', () => {
  registerServiceWorker()

  // Navbar toggle
  const toggle = document.querySelector('.navbar__toggle')
  const menu = document.querySelector('.navbar__menu')

  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      toggle.classList.toggle('active')
      menu.classList.toggle('active')
    })
  }

  // Mount Vue islands
  document.querySelectorAll('[data-vue-component]').forEach((el) => {
    const name = el.dataset.vueComponent
    const component = components[name]

    if (!component) {
      console.warn(`Vue component "${name}" not found in registry`)
      return
    }

    const props = el.dataset.vueProps ? JSON.parse(el.dataset.vueProps) : {}
    const app = createApp(component, props)
    app.mount(el)
  })
})
